import { ResultWaitTimeoutException } from '@/ble/errors/resultWaitTimeout'
import { StandOperationOutcomeResult } from './standService'

// 操作終端表（docs/ble-v14-hardware-support-architecture.md「操作終端と台帳帰結」）の
// 「閉じる」列の写像。変更時は表と本テスト（autoClosePolicy.test.ts）を同時更新する。
// 閉じるのは肯定的証拠が揃ったときだけ（probe成功×フレーム不在 / スイッチ非押下の明示観測）。
// 不明・未確認はすべて閉じない側。

// T12（write失敗）は「未達確定」を証明する手段が無いため閉じない。T11（後開錠タイムアウト）は
// 肯定的証拠3点セット: リンク生存(probe)×フレーム完全不在×定刻発火(受信機健全)が揃った
// ときだけ閉じる。timedOutOnSchedule は「タイマが定刻(operationTimeoutMs+猶予)通りに
// 発火した=受信機(JSランタイム)が待機窓の間ずっと動き続けていた」ことの肯定的証拠であり、
// これが無いと沈黙(sawAnyFrame:false)がランタイム suspend によるフレーム喪失と区別
// できない。それ以外(T10・T15/T16・T6・未知例外)は閉じない。
export function shouldAutoCloseProcess(e: unknown): boolean {
  if (e instanceof ResultWaitTimeoutException) {
    return (
      !e.forcedUnlock &&
      e.linkAlive === true &&
      e.sawAnyFrame === false &&
      e.timedOutOnSchedule === true
    )
  }
  return false
}

// T7（後開錠読取失敗）の写像: failed フレーム受信 × 後開錠 × スイッチ非押下の明示観測。
// 'unknown'（想定外バイト）は結果不明として閉じない。
export function shouldAutoCloseOutcome(
  res: StandOperationOutcomeResult
): boolean {
  return (
    res.outcome === 'failed' &&
    !res.forcedUnlock &&
    res.switchStatus === 'notPressedBoth'
  )
}
